export default __webpack_public_path__ + "static/media/guarddestroyer4.3f6d353c.png";